// extracted by mini-css-extract-plugin
var _1 = "floating-contact-button-module--floatingContactButton--e440b";
var _2 = "floating-contact-button-module--floatingContactButtonIcon--17992";
var _3 = "floating-contact-button-module--floatingContactButtonLabel--64451";
var _4 = "floating-contact-button-module--open--9b24e";
var _5 = "floating-contact-button-module--srOnly--90c8a";
export { _1 as "floatingContactButton", _2 as "floatingContactButtonIcon", _3 as "floatingContactButtonLabel", _4 as "open", _5 as "srOnly" }
